import { createApiThunk } from 'utils/thunkWrapper'
import { getUserChallenges as getUserChallengesApi } from 'api/challenges-v2'
import type { ListUserChallengesResponse } from 'api/types'

export const getSponsoredChallengesForUser = createApiThunk<ListUserChallengesResponse, UserChallengesPayload>({
  action: 'user/getSponsoredChallenges',
  request: (payload) => getUserChallengesApi(String(payload.id), { category: 'CHALLENGE_CATEGORY_SPONSORED' }),
})

// The endpoint returns at most 100 challenges per page, so follow the cursor until every page is loaded.
// The grid pages the combined list client side.
const getAllUserChallenges = async (payload: UserChallengesPayload): Promise<ListUserChallengesResponse> => {
  const data: NonNullable<ListUserChallengesResponse['data']> = []
  const seenCursors = new Set<string>()
  const seenChallengeIds = new Set<string>()
  let response: ListUserChallengesResponse
  let cursor: string | undefined

  do {
    response = await getUserChallengesApi(String(payload.id), { category: payload.category, cursor })
    // According to Core Api: paging consistency isn't guaranteed, so a challenge can appear on more than one page.
    for (const challenge of response.data ?? []) {
      if (challenge.challengeId && seenChallengeIds.has(challenge.challengeId)) {
        continue
      }
      if (challenge.challengeId) {
        seenChallengeIds.add(challenge.challengeId)
      }
      data.push(challenge)
    }
    if (cursor) {
      seenCursors.add(cursor)
    }
    cursor = response.paging?.cursor || undefined
  } while (cursor && !seenCursors.has(cursor) && response.data?.length)

  return { ...response, data }
}

export const getUserChallenges = createApiThunk<ListUserChallengesResponse, UserChallengesPayload>({
  action: 'user/getChallenges',
  request: getAllUserChallenges,
})
